import { isEqual } from "lodash";
import { UserDto } from "./usersApi";

export const filterUsers = (users: UserDto[], search: string) => {
  return users.filter(user => user.displayName.toLowerCase().includes(search.toLowerCase()))
};

export const hasUserChanged = (currentState: UserDto, originalState: UserDto) => {
  if(originalState === undefined) {
    return false
  }

  return !isEqual(currentState, originalState);
}

export const areUserRequiredFieldsEmpty = (user: UserDto | undefined) => {
  return !user || !user.email || !user.displayName
}

export const shouldSaveButtonBeDisabled = (
  userHasChanges: boolean, state: UserDto, isEmailValid: boolean, isNewUser: boolean, isEmailAvailable: boolean
) => {
  return !userHasChanges || areUserRequiredFieldsEmpty(state) || !isEmailValid || (isNewUser && !isEmailAvailable)
}

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
